var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFuturesLoss(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.08 17.27a1 1 0 1 0 1.98-.25l-1.98.25Zm2.12-5.76-.86-.5.86.5ZM25 15.85l-1 .01 1-.01Zm-11.84 7.63a1 1 0 0 0-.71 1.87l.7-1.87Zm-5.1-6.46a8 8 0 0 1 1-5.02l-1.72-1a10 10 0 0 0-1.26 6.27l1.98-.25Zm1-5.02a8 8 0 0 1 3.84-3.38l-.77-1.84A10 10 0 0 0 7.33 11l1.74 1Zm3.84-3.38a8 8 0 0 1 5.1-.37l.5-1.93a10 10 0 0 0-6.37.46l.77 1.84Zm5.1-.37a8 8 0 0 1 4.28 2.8l1.57-1.24a10 10 0 0 0-5.35-3.5L18 8.26Zm4.28 2.8A8 8 0 0 1 24 15.86l2-.03a10 10 0 0 0-2.15-6.02l-1.57 1.24ZM24 15.86a8 8 0 0 1-1.55 4.87l1.61 1.19a10 10 0 0 0 1.94-6.1l-2 .04Zm-1.55 4.87a8 8 0 0 1-4.18 2.94l.56 1.92a10 10 0 0 0 5.23-3.67l-1.61-1.19Zm-4.18 2.94a8 8 0 0 1-5.11-.2l-.71 1.88a10 10 0 0 0 6.38.24l-.56-1.92Z",
    fill: "#DF3030"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 12.5 16 16v3.5",
    stroke: "#F1A7A7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m10.1 18.03-2.05 2.23c-.52.57-1.4.57-1.93 0L4.02 18",
    stroke: "#DF3030",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuturesLoss);
export default __webpack_public_path__ + "static/media/futuresLoss.517d3ea1628e0845f2c019d3153e83ac.svg";
export { ForwardRef as ReactComponent };